import { createQueryKeys } from '@lukemorales/query-key-factory';
import type { BlockListParams } from '@module/apis/client-side/block/type';

export const blockQueryKeys = createQueryKeys('block', {
  fetchBlockList: (fetchBlockListParams: BlockListParams) => [fetchBlockListParams],
  fetchCancelBlock: () => ['cancelBlock'],
  addBlock: () => ['addBlock'],
  fetchBlockWordList: () => ['fetchBlockWordList'],
});
